export default __webpack_public_path__ + "static/media/Coach.9ba8e845.jpg";